import { ReactNode } from 'react';

export const ProfileSection = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  return (
    <div className="py-4 first:pt-0">
      <h3 className="mb-6 text-lg font-semibold text-gray-900">{title}</h3>
      <div className="px-1">{children}</div>
      <div className="mx-auto mt-8 h-px w-4/5 bg-gray-200 last:hidden" />
    </div>
  );
};
